import { ImageIcon } from 'lucide-react'
import { cn } from '@/lib/utils'

// Swap these out with real media. Each placeholder shows its intended subject.
export function ImagePlaceholder({ label = 'Image', className, rounded = 'rounded-2xl' }) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center gap-2 border-2 border-dashed border-primary-300 bg-primary-50/60 text-center text-primary-700/70 select-none',
        rounded,
        className
      )}
      role="img"
      aria-label={`Placeholder: ${label}`}
    >
      <ImageIcon className="h-6 w-6" strokeWidth={1.5} />
      <span className="px-4 text-xs font-medium leading-snug">{label}</span>
    </div>
  )
}
